import styled from "styled-components";

export const DropMessage = styled.div`
	& .dropMessage {
		display: flex;
		align-items: center;
		color: #a7a7a7;
		font-size: 12px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.1px;

		& > div {
			margin: 0px 20px;
	    @media ${({ theme }) => theme.device.mobile} { 
        margin: 0px;
      }
		}

		& .upload {
			display: flex;
			flex-direction: column;
			align-items: center;

			& > img {
				height: 25px;
				width: 25px;
			}
		}

		& .or {
			font-size: 14px;
			color: ${({ theme }) => theme.color.palette.text.main};
		}
	}
	@media ${({ theme }) => theme.device.mobile} {
    .browse {
      width: 100%;
      button {
        width: 100%;
      }
    }
	}
`;

export const DropContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	padding: 24px 32px;
	border: 2px dashed ${({ theme }) => theme.color.palette.border.main};
	border-radius: 8px;
	&:hover {
		cursor: pointer;
	}
`;

export const FileUploadButton = styled.button`
  color: white;
  text-transform: uppercase;
  outline: none;
  background-color: #a7a7a7;
  font-weight: bold;
  padding: 8px 15px;
  margin-bottom: 5px;
`;

export const FileDisplayContainer = styled.div`
  width: 100%;
`;

export const Container = styled.div`
	p {
		color: red;
		text-align: center;
	}
`;

export const FileStatusBar = styled.div`
  width: 100%;
  vertical-align: top;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  &:hover {
    cursor: pointer;
  }

  .progress {
    width: ${({ percentUploaded }) => percentUploaded}%;
    max-width: 100%;
    background-color: rgb(117 205 88 / 0.5);
    content: " ";
    height: 4px;
    transition: width 1s ease-in-out;
    overflow: hidden;
  }
  .progress-enter {
    width: 0%;
  }
  .progress-enter-active {
    transition: width 1s ease-in-out;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  .qb-file-upload-row-left {
    width: 10%;
    display: inline-block;
  }
  .qb-file-upload-row-middle {
    width: 85%;
    display: inline-block;
    border-radius: 8px;
  }
  .qb-file-upload-row-middle:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .qb-file-upload-row-right {
    width: 5%;
    display: inline-block;
  }
`;

export const FileTypeLogo = styled.div`
  width: 50px;
  height: 50px;
  background-size: 100%;
  position: absolute;
`;

export const FileTypeDiv = styled.div`
  display: inline-block;
  font-size: 0.8em;
  font-weight: 700;
  line-height: 1.5em;
  margin: auto;
  padding: 0 8px;
  border-radius: 4px;
  box-shadow: 1px 1px 2px #abc;
  color: #fff;
  background: #0080c8;
  text-transform: uppercase;
`;

export const FileName = styled.span`
  display: inline-block;
  margin-left: 16px;
  overflow-wrap: anywhere;
  color: ${({ error }) => (error ? "#9aa9bb" : "#A7A7A7")};
`;

export const FileSize = styled.span`
  display: inline-block;
  margin-left: 8px;
  color: #444242;
  font-weight: 700;
  font-size: 0.7em;
`;

export const FileErrorMessage = styled.span`
  color: red;
  display: ${({ error }) => (error ? "inline-block" : "none")};
`;

export const FileRemove = styled.div`
  cursor: pointer;
  color: red;
`;

export const PreviewImageModal = styled.div`
  z-index: 999;
  display: none;
  overflow: hidden;

  .overlay {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.66);
    position: fixed;
    top: 0;
    left: 0;
  }

  .modal-image {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    img {
      max-height: 100vh;
      max-width: 100vw;
      background-color: white;
    }
  }

  .close {
    position: fixed;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }
`;

export const UploadModal = styled.div`
  z-index: 999;
  display: none;
  overflow: hidden;

  .overlay {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.66);
    position: absolute;
    top: 0;
    left: 0;
  }

  .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .progress-container {
    background: white;
    width: 500px;
    height: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;

    span {
      display: flex;
      justify-content: center;
      padding-top: 20px;
      font-size: 20px;
    }
  }

  .progress {
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #efefef;
    height: 20px;
    border-radius: 5px;

    .progress-bar {
      position: absolute;
      background-color: #a7a7a7;
      height: 20px;
      border-radius: 5px;
      text-align: center;
      color: white;
      font-weight: bold;
    }
  }
`;
